import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../lib/theme';

export const ThemeToggle = ({ className = '' }) => {
  const { isDark, toggle } = useTheme();
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      title={isDark ? 'Light theme' : 'Dark theme'}
      data-testid="theme-toggle"
      data-theme-state={isDark ? 'dark' : 'light'}
      className={`relative inline-flex h-9 w-9 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-700 transition-[background-color,border-color,transform] duration-200 hover:border-teal-400 hover:text-teal-600 active:scale-95 ${className}`}
    >
      <Sun size={16} className={`absolute transition-[opacity,transform] duration-300 ${isDark ? 'rotate-90 scale-0 opacity-0' : 'rotate-0 scale-100 opacity-100'}`} />
      <Moon size={16} className={`absolute transition-[opacity,transform] duration-300 ${isDark ? 'rotate-0 scale-100 opacity-100' : '-rotate-90 scale-0 opacity-0'}`} />
    </button>
  );
};
